import { render, staticRenderFns } from "./RetiredRole.vue?vue&type=template&id=6d3b52aa"
import script from "./RetiredRole.vue?vue&type=script&lang=js"
export * from "./RetiredRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports